import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import ErrorBoundary from "../ErrorBoundary";

export default function Modal({ data, open, onClose, children }) {
  const dialogRef = useRef(null);
  const title = data?.title ?? "";

  useEffect(() => {
    if (!open) return;

    const handleEscape = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    document.addEventListener("keydown", handleEscape);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", handleEscape);
      document.body.style.overflow = "";
    };
  }, [open, onClose]);

  if (!open) return null;

  // Ensure we have a valid DOM target for the portal.
  const portalRoot = typeof document !== "undefined" ? document.body : null;
  if (!portalRoot) return null;

  const content = (
    <div
      className="ticket-modal__backdrop"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose?.();
      }}
      role="dialog"
      aria-modal="true"
      aria-labelledby="ticket-modal-title"
    >
      <div
        ref={dialogRef}
        className="ticket-modal__dialog"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="ticket-modal__header">
          <h2 id="ticket-modal-title" className="ticket-modal__title">
            Your Order
          </h2>
          <button
            type="button"
            className="ticket-modal__close"
            onClick={onClose}
            aria-label="Close"
          >
            ×
          </button>
        </div>
        <div className="ticket-modal__body">
          {title && <h3 className="ticket__event-title">{title}</h3>}
          <ErrorBoundary
            fallback={({ retry }) => (
              <div className="ticket-error-boundary" role="alert">
                <p className="ticket-error-boundary__message">
                  Something went wrong loading the purchase form.
                </p>
                <button
                  type="button"
                  className="ticket-error-boundary__retry"
                  onClick={retry}
                >
                  Try Again
                </button>
              </div>
            )}
          >
            {children}
          </ErrorBoundary>
        </div>
      </div>
    </div>
  );

  return createPortal(content, portalRoot);
}
